var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4113_5878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.239 9.3252H9.90776C9.58589 9.3252 9.32495 9.58613 9.32495 9.90801V12.2393C9.32495 12.5611 9.58589 12.8221 9.90776 12.8221H12.239C12.5609 12.8221 12.8218 12.5611 12.8218 12.2393V9.90801C12.8218 9.58613 12.5609 9.3252 12.239 9.3252Z",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07959 9.3252H1.74834C1.42646 9.3252 1.16553 9.58613 1.16553 9.90801V12.2393C1.16553 12.5611 1.42646 12.8221 1.74834 12.8221H4.07959C4.40147 12.8221 4.6624 12.5611 4.6624 12.2393V9.90801C4.6624 9.58613 4.40147 9.3252 4.07959 9.3252Z",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15942 1.16553H5.82817C5.5063 1.16553 5.24536 1.42646 5.24536 1.74834V4.07959C5.24536 4.40147 5.5063 4.6624 5.82817 4.6624H8.15942C8.4813 4.6624 8.74224 4.40147 8.74224 4.07959V1.74834C8.74224 1.42646 8.4813 1.16553 8.15942 1.16553Z",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91406 9.3249V7.57646C2.91406 7.42189 2.97547 7.27365 3.08476 7.16435C3.19406 7.05506 3.3423 6.99365 3.49687 6.99365H10.4906C10.6452 6.99365 10.7934 7.05506 10.9027 7.16435C11.012 7.27365 11.0734 7.42189 11.0734 7.57646V9.3249",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99365 6.99385V4.6626",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4113_5878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9875,
    height: 13.9875,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/iot.9162a5a25066729e8b584e60899196f7.svg";
export { ForwardRef as ReactComponent };